import { Col, HeadingText, Link, Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import classNames from 'classnames'
import React, { useEffect } from 'react'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'
import { HERO_MODULE_DATA } from '../../utils/prop-type-shape'

// Hooks
import { useHelper } from '../../hooks/useHelper'
import useTracking from '../../hooks/useTracking'

// styles
import SearchBarV1 from '../search-bar/search-bar-v1'
import './hero-module.less'

// Hero Module Component - The top section with search component
function HeroModule() {
  const { isLoggedIn, getDisplayName, generateLinkWithCoBrand, getPageName } =
    useHelper()
  const { trackActivity } = useTracking()

  useEffect(() => {
    trackActivity({
      name: componentNames.HERO_MODULE,
      type: fptiTypes.SUCCESS,
    })
  }, [])

  const isHomeGreetingEnabled = getPageName() === 'home'
  const renderUserGreering = () => {
    return (
      isHomeGreetingEnabled &&
      isLoggedIn() && (
        <HeadingText
          data-testid="hc-hero-module-user-greeting"
          as="h1"
          size="lg"
        >
          <Message id="app.help.user.greeting" name={getDisplayName()} />
        </HeadingText>
      )
    )
  }

  return (
    <Row
      className={classNames('hero-module', {
        'hero-module--default': !isHomeGreetingEnabled,
        'hero-module--home-page': !!isHomeGreetingEnabled,
      })}
      data-testid="hc-hero-module-section"
    >
      <Col md={6}>
        <Link
          className="hero-module__hc-link"
          href={generateLinkWithCoBrand('/smarthelp/home')}
          data-testid="hc-hero-module-helpcenter-link"
        >
          <Message id="app.helpcenter.title" />
        </Link>

        {renderUserGreering()}

        <SearchBarV1 data-testid="hc-hero-module-search" />
      </Col>
    </Row>
  )
}

HeroModule.propTypes = HERO_MODULE_DATA

export default HeroModule
